<template>
  <div class="add-service-time-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Service Time</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Additional Hours</div>
                <div class="box-col box-col-right">
                  <vue-timepicker tabindex="14" :v-model="serviceTime.numberOfHours"
                    input-class="form-control"
                    placeholder="HH:MM"
                    :minute-interval="15"
                    @change="handleChangeHours"></vue-timepicker>
                  <div v-if="validateHours" class="text-danger">Additional hours is required.</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Service</div>
                <div class="box-col box-col-right">
                  <select class="textbox" v-model="serviceTime.service">
                    <option hidden value="">Select ...</option>
                    <option value="Preparation Time">Preparation Time</option>
                    <option value="Reading Time">Reading Time</option>
                  </select>
                  <div v-if="validateService" class="text-danger">Service is required.</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Reason</div>
                <div class="box-col box-col-right">
                  <textarea v-model="note" class="textbox" :class="reasonError ? 'is-invalid' : ''" placeholder="Please enter reason (optional)" />
                  <div v-if="reasonError" class="text-danger">{{ reasonError }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="icon-group right-float-element">
                  <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                  <v-btn @click="clickSave" dark>Save</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'

  export default {
    name: 'AdminAddServiceTimeModal',
    props: ['bookingProps', 'roleProps', 'fromProps'],
    data() {
      return {
        loadModal: false,
        note: '',
        serviceTime: utilities.initBookingHour(),
        validateHours: false,
        validateService: false,
        bookingId: this.bookingProps.id,
        isPreApproved: false,
      }
    },
    computed: {
      reasonError() {
        return utilities.getAdminBookingAdditionalTimeReasonError(this.note)
      }
    },
    methods: {
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },

      setPreApproved() {
        this.isPreApproved = true
      },

      handleChangeHours(e) {
        if (!/[0-9]{2}:[0-9]{2}/.test(this.serviceTime.numberOfHours)) {
          this.serviceTime.numberOfHours = Number(e.data.H) + Number(e.data.m) / 60
        }
      },

      async clickSave() {
        this.validateHours = false
        this.validateService = false
        this.note = String(this.note || '').trim()
        if (this.reasonError) {
          return
        }

        if (this.serviceTime.numberOfHours == '' && this.serviceTime.service == '') {
          this.validateHours = true
          this.validateService = true
        } else if (this.serviceTime.numberOfHours == '') {
          this.validateHours = true
        } else if (this.serviceTime.service == '') {
          this.validateService = true
        }
        if (this.validateHours == false && this.validateService == false && (this.fromProps == undefined || this.fromProps == '')) {
          await this.postBookingHour()
          this.$parent.additionalTime ++
          this.handleModal()
          this.$store.dispatch('loading/setLoadComponent', false)
        } else if (this.validateHours == false && this.validateService == false && this.fromProps == 'create' && this.roleProps == 'adminAsSpecialist') {
          this.$parent.booking.bookingHours.push({
            id: '',
            isNew: true,
            numberOfHours: this.serviceTime.numberOfHours,
            service: this.serviceTime.service,
            status: 0,
          })
          this.$parent.calculateTotalHour && this.$parent.calculateTotalHour()
          this.handleModal()
          this.$store.dispatch('loading/setLoadComponent', false)
        } else if (this.validateHours == false && this.validateService == false && this.fromProps == 'create') {
          this.$parent.preapprovedHours.push({ numberOfHours: this.serviceTime.numberOfHours, service: this.serviceTime.service })
          this.handleModal()
        }
        this.$forceUpdate()
      },
      async postBookingHour() {
        var userId = this.$parent.user.id
        var userName = this.$parent.user.name
        if (this.roleProps == 'adminAsSpecialist') {
          userId = this.bookingProps.SpecialistID
          userName = this.bookingProps.Specialist.FirstName + ' ' + this.bookingProps.Specialist.Surname
        }
        var serviceTimes = []
        var time = {}
        this.serviceTime.status = 0  // Pending

        time = _.cloneDeep(this.serviceTime)
        time.status =  0
        serviceTimes.push(_.cloneDeep(time))

        await this.$store.dispatch('loading/setLoadComponent', true)
        await utilities.postBookingHour({
          BookingID: this.bookingProps.BookingID,
          Service: this.serviceTime.service,
          NumberHours: this.serviceTime.numberOfHours,
          BookingHoursStatus: 0,
          RequestedBy: userId,
          Reason: this.note
        }, (data) => {
          this.$parent.booking.BookingHours.unshift(data[0])
          this.$parent.calculateTotalHour()
          this.$forceUpdate()
        })

        await this.$store.dispatch('loading/setLoadComponent', false)
      }
    },
    mounted() {},
    updated() {},
  }
</script>
